import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import VideoDetailPage from "../pages/video/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";
import FavoritesPage from "../pages/favorites/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:categoryId",
    element: <CategoryPage />,
  },
  {
    path: "/video/:videoId",
    element: <VideoDetailPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/favorites",
    element: <FavoritesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;